import { Post } from "./common";

export default class MediumService {
  static list = async (token: string) =>
    await Post({ path: "notifications/", token });

  static markAsRead = async (token: string, data: any) =>
    await Post({ path: `notifications/mark-as-read`, token, body: data });

  static markAllAsRead = async (token: string) =>
    await Post({ path: `notifications/mark-all-as-read`, token });
}
